import { useEffect, useRef, useState } from "react";

// Count-up animation for homepage factual counters (values come from DB).
export default function Counter({ value = 0, label, tint, testId }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    started.current = false;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started.current) {
        started.current = true;
        const target = Number(value) || 0;
        const duration = 900;
        const start = performance.now();
        const tick = (t) => {
          const p = Math.min(1, (t - start) / duration);
          const eased = 1 - Math.pow(1 - p, 3);
          setDisplay(Math.round(eased * target));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value]);

  const bg = tint?.bg || "#F4F4F1";
  const fg = tint?.fg || "#111111";

  return (
    <div
      ref={ref}
      data-testid={testId}
      className="flex flex-col justify-between rounded-2xl p-7 sm:p-8 h-40 sm:h-44 transition-transform duration-200 hover:-translate-y-0.5"
      style={{ backgroundColor: bg }}
    >
      <span
        className="text-5xl sm:text-6xl font-extralight tracking-tight tabular-nums leading-none"
        style={{ color: fg }}
      >
        {display}
      </span>
      <span className="text-[11px] sm:text-xs font-medium uppercase tracking-[0.14em] text-neutral-600 leading-snug">
        {label}
      </span>
    </div>
  );
}
